import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import HeroSection from "./components/HeroSection";
import WorksSection from "./components/WorksSection";
import Footer from "./components/Footer";
import ContactSection from "./components/ContactSection";
import Header from "./components/Header";
import AddBusiness from "./pages/AddBusiness";
import BusinessesList from './pages/BusinessesList'; // استيراد الصفحة الجديدة


import "@fortawesome/fontawesome-free/css/all.min.css";

function App() {
  return (
    <Router>
      <Header />
      <nav className="bg-gray-200 p-4">
        <div className="container mx-auto flex justify-between">
          <Link to="/" className="text-indigo-600 hover:underline">الرئيسية</Link>
          <Link to="/add-business" className="text-indigo-600 hover:underline">إضافة عمل</Link>
        </div>
      </nav>
      <Routes>
        <Route path="/" element={
          <>
            <HeroSection />
            <WorksSection />
            <ContactSection />
          </>
        } />
        <Route path="/add-business" element={<AddBusiness />} />
        <Route path="/businesses" element={<BusinessesList />} />

      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
